import Modal from "@/components/ui/modal";
import ProductIdeaForm from "./product-idea-form";

type TProductModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

export default function ProductIdeaModal({ isOpen, onClose }: TProductModalProps) {
    return (
        <Modal
            title="Submit your product idea"
            isOpen={isOpen}
            onClose={onClose}
            className="max-w-lg"
        >
            <ProductIdeaForm closeModal={onClose} />
        </Modal>
    )
}
